import { forwardRef } from "react";
import { BeatLoader, BounceLoader } from "react-spinners";

const Button = forwardRef(({children, color = 'yellow', size = 'normal', className = '', enabled = true, loading = false, ...restProps}, ref) => {
    let cssClasses = ['rounded-full self-center py-2 px-6 cursor-pointer font-bold'];

    if(!enabled) {
        cssClasses[0] = cssClasses[0].replace('cursor-pointer', 'cursor-not-allowed');
        cssClasses.push('bg-gray text-white');
    }
    else if(color === 'yellow') {
        cssClasses.push('bg-yellow text-gray hover:bg-yellow-600');
    } else if(color === 'purple') {
        cssClasses.push('bg-purple text-white hover:bg-purple-600');
    }

    if(size === 'large') {
        cssClasses.push('text-2xl');
    } else {
        cssClasses.push('text-lg');
    }

    cssClasses.push(className);

    return <div ref={ref} className={cssClasses.join(' ')} {...restProps}>
        {loading === true && <BeatLoader color="#fff" speedMultiplier={.75} className="self-center" />}
        {loading === false && children}
    </div>
});

export default Button;
